export const addMemberEnum = {
    personalDetails: 1,
    idProofDetails: 2,
    addressDetails: 3,
    addressProofDetails: 4,
    villageDetails: 5,
    otherDetails: 6,
    nomineeDetails: 7,
    additionalDetails: 8,
}

const userDocumentsStep = {
    pending: 0,
    aadharCard: 1,
    panCard: 2,
    lc: 3,
    other: 4,
}

export const userType = [
    // { name: "admin", value: "Admin" },
    { name: "staff", value: "Staff" },
    { name: "sarthi", value: "Sarthi" },
    { name: "seniorStaff", value: "SeniorStaff" },
    { name: "user", value: "User" },
    { name: "verifyPerson", value: "Verifier" },
    { name: "account", value: "Accountant" },
]

export const userTypeAddMember = [
    // { name: "staff", value: "Staff" },
    // { name: "sarthi", value: "Sarthi" },
    // { name: "seniorStaff", value: "SeniorStaff" },
    { name: "user", value: "User" },
    // { name: "verifyPerson", value: "Verifier" },
    // { name: "account", value: "Accountant" },
]

export const loginRole = [
    { label: "Admin", value: "Admin" },
    { label: "Accountant", value: "Accountant" },
    { label: "Senior Staff", value: "SeniorStaff" },
    { label: "Verify Person", value: "Verifier" },
    { label: "Staff", value: "Staff" },
    { label: "Sarthi", value: "Sarthi" },
]

export const genderList = [
    { label: "Male", value: "Male" },
    { label: "Female", value: "Female" }
]

export const mertialStatus = [
    { label: "Married", value: "Married" },
    { label: "Unmarried", value: "Unmarried" }
]

export const addressProofTypes = [
    { label: "Vera Bill (વેરા બિલ)", value: "Vera Bill" },
    { label: "Electricity Bill (વીજળી બિલ)", value: "Electricity Bill" },
    { label: "Gas Bill (ગેસ બિલ)", value: "Gas Bill" },
    { label: "Society Certy (સોસાયટી પ્રમાણપત્ર)", value: "Society Certy" },
    { label: "Rent Agreement (ભાડા કરાર)", value: "Rent Agreement" },
]

export const idProofTypes = [
    { label: "Driving Licence Card (ડ્રાઇવિંગ લાયસન્સ કાર્ડ)", value: "Driving Licence Card" },
    { label: "Voter ID Card (મતદાર આઈડી કાર્ડ)", value: "Voter ID Card" },
    { label: "Passport (પાસપોર્ટ)", value: "Passport" },
    { label: "PAN Card (પાન કાર્ડ)", value: "PAN Card" },
];

export const castTypes = [
    { label: "Leuva Patel (લેઉવા પટેલ)", value: "Leuva Patel" },
    { label: "Kadva Patel (કડવા પટેલ)", value: "Kadva Patel" }
]

export const additionalDocumentTypeList = [
    { label: "Marriage Certificate (લગ્નનું પ્રમાણપત્ર)", value: "Marriage Certificate", },
    { label: "Affidavit Copy (એફિડેવિટ કોપી)", value: "Affidavit Copy", },
    { label: "Gadget copy of name change (નામ ચેન્જની ગેજેટ કોપી)", value: "Gadget copy of name change", },
    { label: "Other evidence (અન્ય પુરાવા)", value: "Other evidence", },
]

export const occupationList = [
    // { lebal: "Farmer", value: "farmer" },
    { label: "Businessmen", value: "Businessmen" },
    { label: "Self-Employed", value: "Self-employee" },
    { label: "Government Salaried ", value: "Government Salaried" },
    { label: "Private Salaried ", value: "Private Salaried" },
    { label: "Student", value: "Student" },
    { label: "Professional", value: "Professional" },
    { label: "House Wife", value: "House Wife" },
    { label: "Other", value: "Other" },
]

export const educationList = [
    { label: "10th Pass", value: "10th Pass" },
    { label: "12th Pass", value: "12th Pass" },
    { label: "Diploma", value: "Diploma" },
    { label: "Graduate", value: "Graduate" },
    { label: "Post Graduate", value: "Post Graduate" },
    { label: "Doctorate (PhD)", value: "Doctorate (PhD)" },
    { label: "Other", value: "Other" },
]

export const relationList = [
    { label: "Wife (પત્ની)", value: "Wife" },
    { label: "Husband (પતિ)", value: "Husband" },
    { label: "Son (દીકરો)", value: "Son" },
    { label: "Daughter (દીકરી)", value: "Daughter" },
    { label: "Brother (ભાઈ)", value: "Brother" },
    { label: "Sister (બહેન)", value: "Sister" },
    { label: "Father (પિતા)", value: "Father" },
    { label: "Mother (માત)", value: "Mother" },
]

export const bloodGroupsList = [
    { label: "A Positive (A+)", value: "A Positive (A+)" },
    { label: "A Negative (A-)", value: "A Negative (A-)" },
    { label: "B Positive (B+)", value: "B Positive (B+)" },
    { label: "B Negative (B-)", value: "B Negative (B-)" },
    { label: "O Positive (O+)", value: "O Positive (O+)" },
    { label: "O Negative (O-)", value: "O Negative (O-)" },
    { label: "AB Positive (AB+)", value: "AB Positive (AB+)" },
    { label: "AB Negative (AB-)", value: "AB Negative (AB-)" },
]

export const followUpStatusMemberRquest = [
    { label: "Pending", value: "Pending" },
    { label: "OnHold", value: "OnHold" },
    { label: "Confirmed", value: "Confirmed" },
    { label: "Not Interested", value: "Not-Interested" },
    { label: "Follow up running on call", value: "Follow up running on call" },
    { label: "Coming for verification", value: "Coming for verification" },
    { label: "Meeting time scheduled but not come yet", value: "Meeting time scheduled but not come yet" },
    { label: "Meeting done", value: "Meeting done" },
    { label: "Meeting done but confirmation pending", value: "Meeting done but confirmation pending" },
]

export const followUpStatusNotInterSted = [
    { label: "Pending", value: "Pending" },
    { label: "OnHold", value: "OnHold" },
    { label: "Not Interested", value: "Not-Interested" },
    { label: "Follow up running on call", value: "Follow up running on call" },
    { label: "Coming for verification", value: "Coming for verification" },
    { label: "Meeting done", value: "Meeting done" },
]

export const paymentModType = [
    { label: "Cheque", value: 1 },
    { label: "RTGS", value: 2 },
    { label: "QR Code", value: 3 },
    { label: "UPI", value: 4 },
    { label: "NEFT", value: 5 },
    { label: "IMPS", value: 6 },
    { label: "Other", value: 7 },
]



